import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';
import type {
  CompanyDashboardStats,
  MasterAdminDashboardStats,
  OrgDashboardStats,
  OrgStoresSummary,
} from '@/types/dashboard';

export const dashboardApi = {
  masterStats: () =>
    unwrap(api.get<ApiResponse<MasterAdminDashboardStats>>('/v1/dashboard/master')),

  orgStats: (storeId?: number) =>
    unwrap(
      api.get<ApiResponse<OrgDashboardStats>>('/v1/dashboard/org', {
        params: storeId ? { storeId } : undefined,
      }),
    ),

  storesSummary: () =>
    unwrap(api.get<ApiResponse<OrgStoresSummary>>('/v1/dashboard/org/stores-summary')),

  companyStats: () =>
    unwrap(api.get<ApiResponse<CompanyDashboardStats>>('/v1/dashboard/company')),
};
